import React from 'react'
import reactStamp from 'react-stamp'
import Welcome from '../components/Welcome'
import Header from '../components/Header'

export default reactStamp(React).compose({

    render() {

        return (
            <div>
                <Header operations="login,register"/>
                <Welcome greeting="Welcome to anypoint clinic portal"/>
            </div>

        );
        
    },

});


/** WEBPACK FOOTER **
 ** ./src/app/containers/Welcome.js
 **/